// Puškice su privremeno isključene za sve korisnike (uređuju se kasnije).
// Za ponovno uključivanje postaviti na true (i PUSKICE_ENABLED=true na backendu).
export const PUSKICE_ENABLED = false;
